export const dashboardReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_DASHBOARD_COUNT_REQUEST":
      return {
        ...state,
        loading: true,
        dashboardCount: null,
      };
    case "GET_DASHBOARD_COUNT_SUCCESS":
      return {
        ...state,
        loading: false,
        dashboardCount: action.payload,
      };
    case "GET_DASHBOARD_COUNT_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "GET_DASHBOARD_GRAPH_REQUEST":
      return {
        ...state,
        loading: true,
        dashboardGraph: null,
      };
    case "GET_DASHBOARD_GRAPH_SUCCESS":
      return {
        ...state,
        loading: false,
        dashboardGraph: action.payload,
      };
    case "GET_DASHBOARD_GRAPH_FAILED":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
